var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9097",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9097)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.05 8.96667L10.1167 10.9C9.99444 11.0222 9.83889 11.0833 9.65 11.0833C9.46111 11.0833 9.30556 11.0222 9.18333 10.9C9.06111 10.7778 9 10.6222 9 10.4333C9 10.2444 9.06111 10.0889 9.18333 9.96667L11.1167 8.03333L9.18333 6.11667C9.06111 5.99444 9 5.83889 9 5.65C9 5.46111 9.06111 5.30556 9.18333 5.18333C9.30556 5.06111 9.46111 5 9.65 5C9.83889 5 9.99444 5.06111 10.1167 5.18333L12.05 7.11667L13.9667 5.18333C14.0889 5.06111 14.2444 5 14.4333 5C14.6222 5 14.7778 5.06111 14.9 5.18333C15.0333 5.31667 15.1 5.475 15.1 5.65833C15.1 5.84167 15.0333 5.99444 14.9 6.11667L12.9667 8.03333L14.9 9.96667C15.0222 10.0889 15.0833 10.2444 15.0833 10.4333C15.0833 10.6222 15.0222 10.7778 14.9 10.9C14.7667 11.0333 14.6083 11.1 14.425 11.1C14.2417 11.1 14.0889 11.0333 13.9667 10.9L12.05 8.96667Z",
    fill: "#1E1531"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmallIcon);
export default __webpack_public_path__ + "static/media/close_small-icon.9af7c32172d9e3140859978d8138390a.svg";
export { ForwardRef as ReactComponent };